import axiosIns from '../../../xaxios';
import { obtenerUrl } from '../utils';

const procesar = async (id, { estado, observaciones }) => {
  return await axiosIns.put(obtenerUrl(`detalles-solicitudes/procesar/${id}`), { estado, observaciones });
};

const cuentasOrigenPorSede = async (sede_id) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes/cuentas-origen/sede/${sede_id}`));
};

const cuentasDestinoPorSede = async (sede_id) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes/cuentas-destino/sede/${sede_id}`));
};

const conciliacionPorSede = async (sede_id, { params }) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes/conciliacion/sede/${sede_id}/reporte`), {
    params,
    responseType: 'arraybuffer',
  });
};

const obtenerArchivoAdjunto = async (id) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes/${id}/archivo-adjunto`));
};

const subirArchivoAdjunto = async (id, data) => {
  return await axiosIns.post(obtenerUrl(`detalles-solicitudes/${id}/archivo-adjunto`), data);
};

const eliminarArchivoAdjunto = async (id) => {
  return await axiosIns.delete(obtenerUrl(`detalles-solicitudes/${id}/archivo-adjunto`));
};

const obtenerHistorial = async (id) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes/${id}/historial`));
};

const desembolsosPorSedes = async ({ params }) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes/desembolsos-por-sedes`), {
    params,
  });
};

const desembolsosPorSedesExcel = async ({ params }) => {
  return await axiosIns.get(obtenerUrl(`detalles-solicitudes-excel/desembolsos-por-sedes`), {
    params,
    responseType: 'arraybuffer',
  });
};

export default {
  procesar,
  cuentasOrigenPorSede,
  cuentasDestinoPorSede,
  conciliacionPorSede,
  obtenerArchivoAdjunto,
  subirArchivoAdjunto,
  eliminarArchivoAdjunto,
  obtenerHistorial,
  desembolsosPorSedes,
  desembolsosPorSedesExcel,
};
